import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TebFonksiyonService} from '../ctl-teb-fonksiyon.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private service: TebFonksiyonService) {
  }

  getData(control: any) {
    let tableName = control.dlistMetadata.baseEntity;
    const queryParams: string[] = [];

    // Donem query parametresi
    if (this.service.period) {
      queryParams.push(`Donem=${this.service.period}`);
    }

    // Kurumsal query parametresi
    if (this.service.kurumsalKod) {
      queryParams.push(`KurumsalKod=${this.service.kurumsalKod}`);
    }

    // Query string ekle
    if (queryParams.length > 0) {
      tableName = `${tableName}?${queryParams.join("&")}`;
    }

    const dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select();

    const filterArr: any[] = [];
    filterArr.push(["FonksiyonelKod.Length", ">=", 4]);

    // Ek koşullar
    if (this.service.controlCondition) {
      if (this.service.useOrCondition) {
        const combinedOrFilters = this.service.controlCondition
          .map((item: any) => [
            item.conditionColName,
            item.conditionColSymbol,
            item.conditionColText,
          ])
          .reduce(
            (prev, current) => (prev ? [prev, "or", current] : current),
            null
          );

        if (combinedOrFilters) {
          filterArr.push(combinedOrFilters);
        }
      } else {
        this.service.controlCondition.forEach((item: any) => {
          filterArr.push([
            item.conditionColName,
            item.conditionColSymbol,
            item.conditionColText,
          ]);
        });
      }
    }

    dataSource.filter(filterArr);
    return dataSource;
  }


}
